(function ($) {
    var $carousels = $('body').find('.s-logos-slider-items');

    if ($carousels.length > 0) {
        $carousels.each(function () {
            var $carousel = $(this);

            $carousel.slick({
                infinite: true,
                slidesToScroll: 6,
                slidesToShow: 6,
                arrows: true,
                dots: false,
                prevArrow: '<button type="button" class="slick-prev"><i class="icon-left-arrow-big arrow-back"></i></button>',
                nextArrow: '<button type="button" class="slick-next"><i class="icon-left-arrow-big"></i></button>',
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToScroll: 3,
                            slidesToShow: 3
                        }
                    },
                    {
                        breakpoint: 400,
                        settings: {
                            slidesToScroll: 2,
                            slidesToShow: 2
                        }
                    }
                ]
            });
        });
    }

})(jQuery);